import React, { useState, useEffect } from "react";
import { supabase } from "../../supabaseClient";
import ShieldImg from "../../Assets/Icons/shield.png";
import LoaderBox from "./LoaderBox";
import { useLocation } from "react-router-dom";

const HomeResults = () => {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [expandedMatch, setExpandedMatch] = useState(null);
  const location = useLocation();
  const [activeFilter, setActiveFilter] = useState("Svi rezultati");
  const [filterList, setFilterList] = useState(["Svi rezultati"]);
  const [hideDataMode, setHideDataMode] = useState(false);

  const filteredResults = hideDataMode
    ? []
    : results.filter((m) => {
        const matchesFilter =
          activeFilter === "Svi rezultati" || m.group_name === activeFilter;
        const matchesSearch = searchQuery
          ? m.team_a?.name.toLowerCase().includes(searchQuery) ||
            m.team_b?.name.toLowerCase().includes(searchQuery)
          : true;
        return matchesFilter && matchesSearch;
      });
  useEffect(() => {
    const fetchResults = async () => {
      setLoading(true);
      const { data: settings } = await supabase
        .from("site_settings")
        .select("prikazi_rezultate")
        .eq("id", 1)
        .single();

      const rezultatiSuVidljivi = settings ? settings.prikazi_rezultate : false;

      if (
        window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1"
      ) {
        setHideDataMode(false);
      } else {
        setHideDataMode(!rezultatiSuVidljivi);
      }

      // Maknuli smo .order iz queryja jer ćemo sortirati ručno u JS-u
      const { data } = await supabase
        .from("matches")
        .select(`*, team_a:team_a_id (*), team_b:team_b_id (*)`)
        .eq("is_completed", true);
      if (data) {
        const DANI_REDOSLIJED = [
          "Uto 23.6.",
          "Sri 24.6.",
          "Čet 25.6.",
          "Pet 26.6.",
          "Sub 27.6.",
        ];

        data.sort((a, b) => {
          const dayA = DANI_REDOSLIJED.indexOf(a.match_day);
          const dayB = DANI_REDOSLIJED.indexOf(b.match_day);

          if (dayA !== dayB) {
            return dayA - dayB;
          }

          // Ako su isti dan, sortiraj isključivo po satnici (uzlazno, npr. 16:00, 17:00... do 21:00)
          return (a.match_time || "").localeCompare(b.match_time || "");
        });

        setResults(data);

        const groups = data.map((m) => m.group_name).filter(Boolean);
        const uniqueGroups = [...new Set(groups)];
        uniqueGroups.sort((a, b) => {
          if (a === "Završnica") return 1;
          if (b === "Završnica") return -1;
          return a.localeCompare(b);
        });

        setFilterList(["Svi rezultati", ...uniqueGroups]);
      }
      setLoading(false);
    };

    fetchResults();
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const search = params.get("search");
    if (search) setSearchQuery(decodeURIComponent(search).toLowerCase());
  }, [location.search]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const highlightTeam = params.get("highlight");

    if (highlightTeam) {
      const match = results.find(
        (m) =>
          m.team_a?.name.toLowerCase() === highlightTeam.toLowerCase() ||
          m.team_b?.name.toLowerCase() === highlightTeam.toLowerCase(),
      );

      if (match) {
        // Ako filter još nije postavljen, postavi ga i čekaj
        if (activeFilter !== match.group_name) {
          setActiveFilter(match.group_name);
          return; // Izlazi, čekamo sljedeći render gdje će activeFilter biti točan
        }

        // Ako je filter točan, onda skrolaj
        const element = document.getElementById(`match-${match.id}`);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "center" });
          element.classList.add("highlight-pulse");

          setTimeout(() => {
            element.classList.remove("highlight-pulse");
            window.history.replaceState(
              {},
              document.title,
              window.location.pathname,
            );
          }, 3000);
        }
      }
    }
  }, [location.search, activeFilter, results]); // Osluškuj activeFilter!

  const toggleDetails = (matchId) => {
    setExpandedMatch(expandedMatch === matchId ? null : matchId);
  };

  // Filtriranje rezultata ovisno o tabu

  if (loading) return <LoaderBox text="Učitavanje rezultata..." />;

  const EventIcon = ({ type }) => {
    switch (type) {
      case "goal":
        return (
          <div className="goal-icon" title="Gol">
            <i className="fi fi-br-football"></i>
          </div>
        );
      case "penalty":
        return (
          <div className="penalty-icon" title="Penal">
            <i className="fi fi-br-football"></i>
          </div>
        );
      case "penalty-miss":
        return (
          <div className="penalty-icon miss" title="Promašaj">
            <i className="fi fi-rs-cross-small"></i>
          </div>
        );
      case "yellow":
        return (
          <div className="two-min-out-icon" title="2 min">
            <p>2</p>
            <span>min</span>
          </div>
        );
      case "og":
        return (
          <div className="autogoal c-og" title="Autogol">
            AG
          </div>
        );
      default:
        return <div className="c-icon c-default">?</div>;
    }
  };

  return (
    <div className="results-view-wrapper">
      {/* Tab Navigacija (Scrollable) */}
      <div className="day-navigation-tabs results-filter-tabs">
        {filterList.map((f) => (
          <button
            key={f}
            className={activeFilter === f ? "active" : ""}
            onClick={() => {
              setActiveFilter(f);
              setExpandedMatch(null);
            }}
          >
            {f === "Svi rezultati"
              ? "Svi rezultati"
              : f === "Završnica"
                ? "Završnica"
                : `Grupa ${f}`}
          </button>
        ))}
      </div>

      <div className="results-container">
        {filteredResults.length === 0 ? (
          <div className="empty-state results-empty">
            <div className="icon-wrapper">
              <i className="fi fi-rs-info"></i>
            </div>
            <p>Nema rezultata za odabrani filter.</p>
          </div>
        ) : (
          filteredResults.map((match) => (
            <div
              key={match.id}
              id={`match-${match.id}`}
              className={`result-card ${expandedMatch === match.id ? "active" : ""}`}
            >
              <div className="result-group-tag">
                <span>
                  {(() => {
                    if (match.group_name === "Završnica") {
                      // Filtriramo sve utakmice završnice kako bismo znali njihov točan redoslijed kroz dan
                      const sveUtakmiceZavrsnice = filteredResults.filter(
                        (m) => m.group_name === "Završnica",
                      );
                      const trenutniIndeks = sveUtakmiceZavrsnice.findIndex(
                        (m) => m.id === match.id,
                      );

                      if (trenutniIndeks >= 0 && trenutniIndeks <= 7)
                        return "1/8 Finale";
                      if (trenutniIndeks >= 8 && trenutniIndeks <= 11)
                        return "1/4 Finale";
                      if (trenutniIndeks >= 12 && trenutniIndeks <= 13)
                        return "Polufinale";
                      if (trenutniIndeks === 14) return "FINALE";

                      return "Završnica";
                    }

                    return `Grupa ${match.group_name}`;
                  })()}
                </span>
                <span>{match.match_day}</span>
              </div>

              <div
                className="result-main"
                onClick={() => toggleDetails(match.id)}
              >
                <div className="res-team left">
                  {" "}
                  <img src={match.team_a?.logo_url || ShieldImg} alt="logo" />
                  <span className="res-team-name">{match.team_a?.name}</span>
                </div>

                <div className="res-score">
                  <span className="score-num">{match.scorea}</span>
                  <span className="score-divider">:</span>
                  <span className="score-num">{match.scoreb}</span>
                </div>

                <div className="res-team right">
                  <img src={match.team_b?.logo_url || ShieldImg} alt="logo" />
                  <span className="res-team-name">{match.team_b?.name}</span>
                </div>

                <div
                  className={`res-arrow ${expandedMatch === match.id ? "open" : ""}`}
                >
                  <i className="fi fi-rs-angle-small-down"></i>
                </div>
              </div>

              {expandedMatch === match.id && (
                <div className="result-details">
                  <div className="details-header">Tijek utakmice</div>
                  <div className="details-timeline">
                    {match.events && match.events.length > 0 ? (
                      match.events
                        .slice()
                        .sort((a, b) => parseInt(a.time) - parseInt(b.time))
                        .map((event, idx) => (
                          <div
                            key={idx}
                            className={`detail-row ${event.team === "A" ? "left" : "right"}`}
                          >
                            <div className="detail-info">
                              <span className="detail-time">{event.time}'</span>
                              <EventIcon type={event.type} />
                              <span className="detail-player">
                                {event.player}
                              </span>
                            </div>
                          </div>
                        ))
                    ) : (
                      <div className="no-events">
                        Nema zabilježenih događaja.
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default HomeResults;
